<!-- 中间地图区域部分 -->
<template>
  <div class="sichuan" id="myMap" ref="charts1"></div>
</template>
<script>
import geoJson from '../../plugins/mapjs/sichuan.json';
import * as echarts from 'echarts';
let myEchart = null; //地图
import axios from 'axios';
export default {
  data() {
    return {
      option: {
        textStyle: {
          color: 'white',
        },
        geo: [
          {
            map: 'sichuan',
            aspectScale: 1, //用于 scale 地图的长宽比
            zoom: 0.9,
            layoutCenter: ['50%', '50%'], //定义地图中心在屏幕中的位置
            layoutSize: '150%', //地图的大小
            show: true, //是否显示地理坐标系组件。
            roam: false, //是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
            label: {
              //图形上的文本标签
              show: true,
              color: '#fff',
              borderColor: 'rgba(72,203,137,0)',
              align: 'center',
              borderRadius: 2,
              borderWidth: 1,
              formatter: function (params) {
                const name = params.name;
                // 对特定地区应用不同样式
                if (name) {
                  return `{b|${name}}`; // 长名称使用不同样式
                }
              },
              rich: {
                b: {
                  color: '#fff',
                  backgroundColor: {
                    image: require('../../../public/home/homePonit.png'),
                  },
                  fontSize: 14,
                  height: 18,
                  lineHeight: 18,
                  align: 'center',
                },
              },
            },
            tooltip: {
              show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
              trigger: 'item', //触发类型。item,axis,none
              enterable: true, //鼠标是否可进入提示框浮层中，默认为false，
              showContent: true, //是否显示提示框浮层
              triggerOn: 'mousemove', //提示框触发的条件(mousemove|click|none)
              showDelay: 0, //浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 triggerOn 为 'mousemove' 时有效。
              textStyle: {
                color: 'white',
                fontSize: 12,
              },
              padding: 0,
              position: function (pt, params) {
                if (params.componentSubType == 'effectScatter') {
                  return ['15%', 0];
                } else {
                  let X = pt[0];
                  let Y = pt[1];
                  return [X + 10, Y + 10];
                }
              },
              hideDelay: 10,
              backgroundColor: 'rgba(0,0,0,0)', //提示框浮层的背景颜色。
              borderColor: 'rgba(0,0,0,0)', //图形的描边颜色
              borderWidth: 1,
              alwaysShowContent: true,
              transitionDuration: 1,
            },
            itemStyle: {
              //地图区域的颜色
              areaColor: {
                type: 'linear',
                x: 5,
                y: 210,
                x2: 65,
                y2: 10,
                colorStops: [
                  {
                    offset: 0,
                    color: '#fff',
                  },
                  {
                    offset: 1,
                    color: '#fff',
                  },
                ],
                global: true, // 缺省为 false
              },
              borderColor: 'rgba(72, 203, 137, 1)',
              borderWidth: 1,
              shadowColor: 'rgba(72,203,137,0.56)', // 阴影颜色
              shadowBlur: 10, // 阴影模糊大小
              shadowOffsetX: 5, // 水平偏移
              shadowOffsetY: 5 // 垂直偏移
            },
            //高亮状态下的多边形和标签样式
            emphasis: {
              itemStyle: {
                show: false,
                color: '#fff',
                areaColor: {
                  type: 'linear',
                  x: 100,
                  y: 100,
                  x2: 400,
                  y2: 400,
                  colorStops: [
                    { offset: 0, color: '#48CB89FF' },
                    { offset: 1, color: 'rgba(72,203,137,0.56)' },
                  ],
                  global: true, // 缺省为 false
                },
              },
              label: {
                show: true,
                color: '#fff',
              },
            },
          },
        ],

        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4,
            },
            label: {
              show: true,
              color: '#fff',
            },
            symbol: 'pin', //定位图标样式
            symbolSize: 50,
            symbolOffset: [0, -5],
            //点的名称和经纬度
            data: [],
          },
        ],
      },
      markerData: [],
    };
  },
  mounted() {
    myEchart = this.$echarts.init(document.getElementById('myMap'));
    this.initEchart();
    window.addEventListener('resize', () => {
      myEchart.resize();
    });
  },
  methods: {
    initEchart() {
      echarts.registerMap('sichuan', geoJson);
      // 模拟后端请求的数据
      let markerList = [
        {
          name: '成都市',
          count: (Math.random() * 100).toFixed(0),
        },
        {
          name: '甘孜藏族自治州',
          count: (Math.random() * 100).toFixed(0),
        },
        {
          name: '乐山市',
          count: (Math.random() * 100).toFixed(0),
        },
      ];
      this.getCenter(markerList, 0)
      this.option.series[0].data = this.markerData;
      myEchart.setOption(this.option);
    },
    getCenter(list, index) {
      return new Promise((resolve, reject) => {
        geoJson.features.forEach((item) => {
          if (item.properties?.name == list[index]?.name) {
            this.markerData.push({
              name: list[index].name,
              value: item.properties.centroid,
              label: {
                formatter: list[index].count, //圆环显示文字
              },
              itemStyle: {
                color: '#16AB61FF',
              },
            });
            if(index >= list.length){
              resolve('success')
              return
            }else {
              this.getCenter(list, index + 1);
            }

          }
        });
      });
    },
  },
};
</script>
<style>
.sichuan {
  width: 100%;
  height: 100%;
}
</style>
